export const RESET = 'CITY_UPDATE_RESET'
export const SET_ERROR = 'CITY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CITY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CITY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CITY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CITY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CITY_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'CITY_UPDATE_FILES'
